import React from 'react'
import { connect } from 'react-redux'
import { useLocation } from 'react-router-dom'
import ProductionRatesTable from './ProductionRatesTable'
import LaborRatesTable from './LaborRatesTable'
import EquipmentRatesTable from './EquipmentRatesTable'
import MaterialCatalogTable from './MaterialCatalogTable'
import ServiceAttributesTab from './ServiceAttributesTab'
import DisposalDashboard from './DisposalDashboard'
import BidEstimationHeader from '../shared/BidEstimationHeader'
import RecipeBuilderV2 from '../ServiceRecipes/v2/RecipeBuilderV2'

const TABS = [
  { key: 'production',  label: 'Production Rates' },
  { key: 'labor',       label: 'Labor Rates' },
  { key: 'equipment',   label: 'Equipment Rates' },
  { key: 'material',    label: 'Material Catalog' },
  { key: 'recipes',     label: 'Service Recipes' },
  { key: 'attributes',  label: 'Service Attributes' },
  { key: 'disposal',    label: 'Disposal & Hauling' }
]

const RateTablesView = (props) => {
  const [tab, setTab] = React.useState(0)
  const location = useLocation()

  const fromProjectId = location.state && location.state.fromProjectId
  const fromProjectName = location.state && location.state.fromProjectName
  const breadcrumbs = fromProjectId
    ? [
      { label: 'Bid Estimation', to: '/bid-estimation' },
      { label: fromProjectName || 'Project', to: `/bid-estimation/${fromProjectId}` },
      { label: 'Rate Tables' }
    ]
    : [
      { label: 'Bid Estimation', to: '/bid-estimation' },
      { label: 'Rate Tables' }
    ]

  return (
    <div className="hmi-page" style={{ position: 'fixed', inset: 0, zIndex: 1200, overflow: 'auto' }}>
      <BidEstimationHeader
        breadcrumbs={breadcrumbs}
        title="Rate Tables"
      />

      {/* Tab bar */}
      <div className="hmi-tab-bar">
        {TABS.map((t, i) => (
          <button
            key={t.key}
            className={`hmi-tab${tab === i ? ' active' : ''}`}
            onClick={() => setTab(i)}
          >
            {t.label}
          </button>
        ))}
      </div>

      {/* Tab content */}
      <div className="hmi-body">
        {tab === 0 && <ProductionRatesTable url={props.url} />}
        {tab === 1 && <LaborRatesTable url={props.url} />}
        {tab === 2 && <EquipmentRatesTable url={props.url} />}
        {tab === 3 && <MaterialCatalogTable url={props.url} />}
        {tab === 4 && <RecipeBuilderV2 />}
        {tab === 5 && <ServiceAttributesTab url={props.url} />}
        {tab === 6 && <DisposalDashboard url={props.url} />}
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  url: state.url,
  user: state.user,
  authenticated: state.authenticated
})

export default connect(mapStateToProps)(RateTablesView)
